import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getNodeList, importRequested } from './logic';
import { NodeLabel } from '../../../general/node';
import { FigmaIcon } from './FigmaIcon';
import { differenceBy } from 'lodash';
import { ToolbarButton } from '../toolbarButton';

/**
 * Что именно импортировать и активна ли кнопка — одно и то же для «сырой»
 * кнопки просмотрщика и для тулбарной; логика вынесена сюда, чтобы у обеих
 * не расходился набор нод.
 */
function useFigmaImport(nodes: NodeLabel[] | null) {
  const dispatch = useDispatch();
  const list = useSelector(getNodeList);
  const newNodes = differenceBy(nodes, list, (x) => x.id);
  const disabled = newNodes.length === 0;
  return {
    disabled,
    onClick: () => {
      if (disabled) return;
      dispatch(importRequested(newNodes));
    },
  };
}

export const FigmaButtonRaw: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & { nodes: NodeLabel[] | null }
> = ({ nodes, ...props }) => {
  const { disabled, onClick } = useFigmaImport(nodes);
  const ch = props.children;
  return (
    <button onClick={onClick} id="ch-figma-button" disabled={disabled} {...props}>
      <FigmaIcon />
      {ch}
    </button>
  );
};

export const FigmaButton: React.FC<{
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  nodes: NodeLabel[] | null;
}> = ({ onMouseEnter, onMouseLeave, nodes }) => {
  const { disabled, onClick } = useFigmaImport(nodes);
  return (
    <ToolbarButton
      disabled={disabled}
      onClick={onClick}
      className="ch-figma"
      id="ch-figma-button"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      icon={<FigmaIcon />}
    />
  );
};
